import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import AboutSection from "./components/AboutSection";
import ProductsSection from "./components/ProductsSection";
import FeaturesSection from "./components/FeaturesSection";
import ContactSection from "./components/ContactSection";

export default function Home() {
  return (
    <main className="w-full min-h-screen font-sans bg-white">
      <Navbar />
      <HeroSection />
      <AboutSection />
      <ProductsSection />
      <FeaturesSection />
      <ContactSection />
    </main>
  );
}
